'use strict';

/**
 * @desc ui-semantic searchable dropdown wrapper
 * @example <sm-dropdown
 *                sm-data="[{name: 'United States', value: 'US', icon: 'flag US'},{name: 'Denmark', value: 'DK', icon: 'flag DK'}]"
 *                sm-dropdown-options="{allowAdditions: true, otherConfiguration: 'other'}"
 *                ng-model="$ctrl.something" />
 */

function smDropdown($timeout, gettextCatalog) {
  return {
    scope: {
      dropdownOptions: '=smDropdownOptions',
      data: '=smData',
    },
    require: 'ngModel',
    restrict: 'E',
    replace: true,
    template:
      '' +
      '<div class="ui selection dropdown">' +
      '   <input type="hidden" name="options">' +
      '   <i class="dropdown icon"></i>' +
      '   <div class="default text">{{dropdownOptions.defaultText}}</div>' +
      '   <div class="menu">' +
      '     <div class="item" ng-repeat="item in data track by $index" data-value="{{item.value}}">' +
      '         <i ng-if="item.icon" class="{{item.icon}}"></i>' +
      '         {{item.name}}' +
      '     </div>' +
      '   </div>' +
      '</div>',
    link: function (scope, element, attributes, ngModelCtrl) {
      if (scope.dropdownOptions && scope.dropdownOptions.search === true) {
        element.addClass('search');
      }

      // extend the options
      var options = _.extend(
        {
          hideAdditions: true,
          fullTextSearch: true,
          message: {
            addResult:
              '<b>{term}</b> (' + gettextCatalog.getString('create new') + ')',
            count: gettextCatalog.getString('{count} selected'),
            noResults: gettextCatalog.getString('No results found.'),
          },
          onChange: function (value) {
            // when the value of the dropdown changes, update the ng-model
            $timeout(function () {
              ngModelCtrl.$setViewValue(value);
            });
          },
        },
        scope.dropdownOptions
      );

      // initialize the dropdown
      element.dropdown(options);

      // when the value of ng-model changes from outside the directive, semantic-ui should update its selected
      ngModelCtrl.$render = function () {
        $timeout(function () {
          element.dropdown('set selected', ngModelCtrl.$modelValue);
        });
      };
    },
  };
}

angular.module('cdPay.directives').directive('smDropdown', smDropdown);
